import { colors } from '../styles'

export const heading = {
  baseStyle: {
    fontWeight: 600,
    color: colors.gray[900],
    fontStyle: 'normal',
  },
  variants: {
    h1: {
      fontSize: 64,
      lineHeight: '80px',
    },
    h2: {
      fontSize: { base: '48px', lg: '40px' },
      lineHeight: '64px',
    },
    h3: {
      fontSize: 36,
      lineHeight: '46px',
    },
    h4: {
      fontSize: 24,
      lineHeight: '36px',
    },
    h5: {
      fontSize: '20px',
      lineHeight: '26px',
    },
    h6: {
      fontSize: 18,
      lineHeight: '28px',
    },
  },
  defaultProps: {
    variant: 'h1',
  },
}
